<!-- <div class="preloader" [hidden]="load">
  <div class="loading">
      <img src="assets/images/loader/loader.svg">
  </div>
</div> -->

<app-loading [hidden]="load"></app-loading>
<section class="text-content pt-80 pb-80">
  <div class="container">

      <div class="row">

          <div class="col-sm-12 col-md-12 col-lg-12" style=" text-align: center;">
              <h5 class="text__block-title mb-20 HTitle" style="border-radius: 40px 0px 40px 40px;">{{ResearchTopicName}}</h5>
          </div>
          <div class="offset-lg-2 col-sm-10 col-md-10 col-lg-10 pl" style="text-align: center;">
            <p class="pDetails" [innerHtml]="ResearchTopicDetails"></p>
            <figure>
              <img [src]="ResearchTopicImg">
              <figcaption>{{ResearchTopicDsc}}</figcaption>
            </figure>
              
          </div>
      </div>
      <!-- <div class="row col-sm-12 col-md-12 col-lg-12 offset-lg-1" style="padding-left: 80px;">
        <figure>
          <img [src]="ResearchTopicImg">
          <figcaption>{{ResearchTopicDsc}}</figcaption>
        </figure>
    </div> -->
      <!-- <div class="row pt-100 pb-60 ">
          <div class="offset-lg-2 col-sm-10 col-md-10 col-lg-10 pl">
            <p>{{ResearchTopicDsc}}</p>
              <p class="pDetails" [innerHtml]="ResearchTopicDetails"></p>
          </div>
      </div> -->
  </div>
</section>

